import React from "react";
import { Link } from "react-router-dom";
import { LANDING_PATHS } from "@/lib/landingPaths";

const MainFooter = () => (
  <footer className="py-12 border-t border-white/[0.05]" data-testid="choice-footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="flex flex-col md:flex-row items-center justify-between gap-6">
        <Link to="/" className="flex items-center">
          <img src="/images/logo.png" alt="FractoLabs" className="w-full max-w-[100px]" />
        </Link>

        <div className="flex flex-wrap justify-center gap-8 text-gray-500 text-sm">
          <Link to={LANDING_PATHS.roofing} className="hover:text-white transition-colors">
            Roofing Interceptor
          </Link>
          <Link to={LANDING_PATHS.realEstate} className="hover:text-white transition-colors">
            AI Broker
          </Link>
          <Link to="/privacy-policy" className="hover:text-white transition-colors">
            Privacy Policy
          </Link>
          <Link to="/terms" className="hover:text-white transition-colors">
            Terms of Service
          </Link>
          <Link to="/dpa" className="hover:text-white transition-colors">
            DPA
          </Link>
          <Link to="/contact" className="hover:text-white transition-colors">
            Contact Us
          </Link>
          <Link to="/login" className="hover:text-white transition-colors">
            Login
          </Link>
        </div>

        <p className="text-gray-600 text-sm font-mono">© {new Date().getFullYear()} FractoLabs</p>
      </div>
    </div>
  </footer>
);

export default MainFooter;
